

























import EmojiPicker from 'vue-emoji-picker';
export default {
    components: {
        EmojiPicker
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            search: ''
        };
    },
    methods: {
        append(emoji: string) {
            this.$emit('append', emoji);
        }
    },
    directives: {
        focus: {
            inserted(el: any) {
                el.focus();
            },
        },
    },
};
